(function ($, window, document) {

function onDOMContentLoaded() {
  $(window).resize(bulletize);

  function bulletize() {
    var previousElement = false;
    $('.footer__info li').each(function (index, item) {
      var $element = $(item);
      if (previousElement && previousElement.offset().top === $element.offset().top) {
        $element.addClass('square');
      } else {
        $element.removeClass('square');
      }

      previousElement = $element;
    });
  }

  // adjust when document is ready
  bulletize();
}
if (document.readyState == 'loading') {
  document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
} else {
  onDOMContentLoaded();
}

})(jQuery, window, document);
